import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
    this.handleNavLinkClick = this.handleNavLinkClick.bind(this);
    document.addEventListener("click", this.handleNavLinkClick);

    if (window.matchMedia("(max-width: 767px)").matches) {
      // Mobile uses the bottom sheet, not inline fullscreen — clear any state left over from desktop.
      delete this.element.dataset.fullscreen;
      sessionStorage.removeItem("massimo-fullscreen");
    } else if (sessionStorage.getItem("massimo-fullscreen")) {
      this.expand();
    }
    if (sessionStorage.getItem("massimo-chat-id") === "history") {
      this.element.dataset.activePanel = "history";
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
    document.removeEventListener("click", this.handleNavLinkClick);
  }

  expand() {
    if (window.matchMedia("(max-width: 767px)").matches) return;
    this.element.dataset.fullscreen = "";
    sessionStorage.setItem("massimo-fullscreen", "true");
  }

  minimize() {
    this.element.dataset.noTransition = "";
    delete this.element.dataset.fullscreen;
    sessionStorage.removeItem("massimo-fullscreen");
    requestAnimationFrame(() => delete this.element.dataset.noTransition);
  }

  showHistory(event) {
    if (event) event.preventDefault();
    sessionStorage.setItem("massimo-chat-id", "history");
    this.element.dataset.activePanel = "history";
  }

  showChat() {
    sessionStorage.removeItem("massimo-chat-id");
    delete this.element.dataset.activePanel;
  }

  // connect() only applies the stored fullscreen/history state on page load, so an opener that fires
  // later on the same page (ui--open-mo) needs this: expand when it asked for fullscreen, and switch to
  // the history tab when it set massimo-chat-id=history. Wired after admin--massimo-panel#openPanel,
  // which checks the toggle first and, on mobile, strips fullscreen — expand() no-ops there anyway.
  applyOpenIntent(event) {
    if (event?.detail?.fullscreen) this.expand();
    if (sessionStorage.getItem("massimo-chat-id") === "history") this.showHistory();
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.element.hasAttribute("data-fullscreen")) {
      this.minimize();
    }
  }

  // Side-nav links and resource chips in Mo's responses are full page loads (data-turbo="false"). If
  // Mo is fullscreen, the destination would otherwise render behind the fullscreen overlay, so drop out
  // of fullscreen and let Mo render docked. minimize() clears the massimo-fullscreen sessionStorage
  // key; massimo-open is left intact so Mo stays open.
  handleNavLinkClick(event) {
    if (!this.element.hasAttribute("data-fullscreen")) return;
    const link = event.target.closest(
      ".admin-nav a[href], [data-controller~='admin--massimo--markdown'] a[href]",
    );
    if (!link || link.target === "_blank") return;
    this.minimize();
  }
}
